import { dialogManager } from "./dialog-manager";

export function useDialog() {
  return {
    alert: dialogManager.alert,
    closeAll: dialogManager.closeAll,
    confirm: dialogManager.confirm,
    confirmDelete: dialogManager.confirmDelete,
    open: dialogManager.open,
  } as const;
}
